import NavBottom from './NavBottom.container'

export default NavBottom
